export default "__VITE_ASSET__mFUSrsOE__"